import { Input } from "@xanadu/model";
import { DataCache } from "./data.cache";
import { DataService } from "../../service/data/data.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class InputCache extends DataCache<Input> {

    constructor(
        dataService: DataService
    ) {
        super(Input, dataService);
    }
}
